import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable()
export class CareerService {
  api_url: string = environment.apiEndPoint;

  constructor(private http: HttpClient) {}

  getToken() {
    return localStorage.getItem(environment.TOKEN_SECRET);
  }

  geAllCareers() {
    const configs = {
      withCredentials: true,
      headers: { Authorization: `Bearer ${this.getToken()}` },
    };
    return this.http.get<any>(this.api_url + "jobs",configs);
  }
  saveCareers(obj) {
    const configs = {
      withCredentials: true,
      headers: { Authorization: `Bearer ${this.getToken()}` },
    };
    if (obj._id) {
      return this.http.put<any>(this.api_url + "jobs/" + obj._id, obj, configs);
    }
    return this.http.post<any>(this.api_url + "jobs", obj, configs);
  }
  deleteCareer(obj) {
    const configs = {
      withCredentials: true,
      headers: { Authorization: `Bearer ${this.getToken()}` },
      body: obj,
    };
    return this.http.delete<any>(this.api_url + "jobs/" + obj._id, configs);
  }
  getCandidate(job_id) {
    const configs = {
      withCredentials: true,
      headers: { Authorization: `Bearer ${this.getToken()}` },
    };
    return this.http.get<any>(this.api_url + "candidates/" + job_id,configs);
  }
}



// WEBPACK FOOTER //
// ./src/app/careers/career.service.ts